import { CharacteristicImage, SampleImage } from '@core/data';
import { ImageMoveImageType } from './image-move.state-model';

export class ToggleImageSelection {
    static readonly type = "[ImageMove] Toggle Selection";
    constructor(public image: SampleImage | CharacteristicImage, public imageType: ImageMoveImageType){}
}

export class ClearImageSelection {
    static readonly type = "[ImageMove] Clear Selection";
    constructor(){}
}

export class TransferImages {
    static readonly type = "[ImageMove] Transfer Images";
    constructor(public imageKeys: string[], public destinationEvalKey: string, public imageType: ImageMoveImageType = 'sample'){}
}

export class UndoImageTransfer {
    static readonly type = "[ImageMove] Undo Transfer";
    constructor(public imageKeys: string[], public sourceEvalKey: string, public imageType: ImageMoveImageType = 'sample', public previousEvalKey?: string){}
}
